module.exports = __webpack_public_path__ + "img/delete_col_fd.fb22dea8.svg";